import React, { Fragment, useEffect, useState, useCallback } from "react";
import { useForm } from "react-hook-form";
import 'react-toastify/dist/ReactToastify.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Spinner from "../FieldComponets/Spinner";
import { ErrorMessage } from '@hookform/error-message';
import { useDispatch, useSelector } from 'react-redux';
import ToastDefault from "../FieldComponets/Toast";
import PageLayout from "../Layouts/PageLayout";
import { SalondeletebusinessAction, SalonUpdateAction } from "../../Redux/Action/SalonAction";
import Swal from 'sweetalert2'
import { StorageConstant, VALIDATION_MESSAGE } from "../../Constants/Constants";
import { BASE_URL, url } from "../../Config/Config";
import { ImageUrl, decodeID, getLastURL, replaceToString, userPicUrl } from '../../utils/Helper';
import { SalonDetailsAction } from "../../Redux/Action/SalonAction";
import { toast } from "react-toastify";
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import CommanPhoneNumber from "../Layouts/CommanPhoneNumber";


interface FormInputs {
    location: string,
    description: string,
    phone_number: string,
    salon_name: string,
    owner_name: string,
    email: string,
    owner_experience: string,
    buisness_images: File[],
    salon_id: string,
    phone_country_code:string


}
function SalonEdit() {
    const dispatch = useDispatch<any>();
    const navigate = useNavigate()
    const location = useLocation();
    const editId = getLastURL(location);
    const log_in = useSelector((state: any) => state.SalonDetailGetState)
    const updateStatus = useSelector((state: any) => state?.SalonUpdateState)
    const deleteStatus = useSelector((state: any) => state?.SalonBussianImageGetState)
    const salondata = useSelector((state: any) => state?.SalonDetailGetState?.data?.data?.detail)
    const [loading, setLoading] = useState(false)
    const [images, setImages] = useState<any>([]);


    const handleDeleteBusinessImage = async (e: any) => {
        if (!e?.media_id) {
            Swal.fire({
                title: VALIDATION_MESSAGE?.ARE_YOU_SURE,
                text: VALIDATION_MESSAGE?.BUSINESS_REMOVE_IMAGE,
                icon: 'warning',
                // showCancelButton: true,
                confirmButtonColor: '#31CE36',
                cancelButtonColor: '#d33',
                showDenyButton: true,
                denyButtonText: 'No',
                confirmButtonText: 'Yes',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    setImages((prevImages: any) =>
                        prevImages.filter((file: any) => file?.name != e?.name)
                    );
                }
            });

        } else {
            Swal.fire({
                title: VALIDATION_MESSAGE?.ARE_YOU_SURE,
                text: VALIDATION_MESSAGE?.BUSINESS_REMOVE_IMAGE,
                icon: 'warning',
                // showCancelButton: true,
                confirmButtonColor: '#31CE36',
                cancelButtonColor: '#d33',
                showDenyButton: true,
                denyButtonText: 'No',
                confirmButtonText: 'Yes',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const data = {
                        delete_id: e.media_id,
                        salon_id: salondata.id as any, // Assuming id is of type any
                    };
                    // return console.log(data)
                    dispatch(SalondeletebusinessAction(data))
                    setLoading(true)

                }
            });

        }
    }

    const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) {
            const files = Array.from(event.target.files);

            // Filter files to include only JPG and JPEG formats
            const validImageTypes = ['image/jpeg', 'image/jpg', 'image/png'];
            const filteredFiles = files.filter(file => {
                const fileType = file.type;
                return validImageTypes.includes(fileType);
            });

            // If any files were filtered out, show an alert
            if (filteredFiles.length !== files.length) {
                toast.error('Please select only JPG , JPEG or PNG images.')
            } else {
                // Add filtered files to state
                setImages((prevImages: any) => [...prevImages, ...filteredFiles]);
            }
        }
    };

    const renderImages = () => {
        const combinedImages = [
            ...(salondata?.buisness_images || []),
            ...images.map((file: any) => ({ file_path: URL.createObjectURL(file), name: file.name }))
        ];
        return new Array(10).fill(null).map((_, index) => {
            if (combinedImages[index]) {
                return (
                    <div className="cat-img-view" key={index}>
                        <img
                            src={userPicUrl(combinedImages[index]?.file_path)}
                            className="rounded-circle"
                            alt=""
                        />
                        {combinedImages.length > 5 && (
                            <button
                                type='button'
                                className='btn btnDelete'
                                onClick={() => handleDeleteBusinessImage(combinedImages[index])}
                            >
                                <i className="fas fa-trash-alt"></i>
                            </button>
                        )}
                    </div>
                );
            } else {
                return (
                    <label className="cat-img-view mb-0 cursor-pointer " key={index} htmlFor="imageb">
                        <i className="fa fa-upload" aria-hidden="true"></i>
                        <input type="file" id="imageb" className="form-control d-none" onChange={handleImageChange} />
                    </label>
                );
            }
        });
    };

    const formSchema: any = Yup.object().shape({
        salon_name: Yup.string()
            .required('Please enter salon name.')
            .trim()
            .min(3, 'Salon name must be more than 2 characters.')
            .max(25, 'Salon name should not exceed 50 characters.'),
        owner_name: Yup.string()
            .required('Please enter owner name.')
            .trim()
            .min(3, 'Owner name must be more than 2 characters.')
            .max(25, 'Owner name should not exceed 50 characters.'),
        description: Yup.string()
            .required('Please enter description.')
            .trim()
            .min(10, 'Description must be more than 2 characters.')
            .max(250, 'Description should not exceed 50 characters.'),
            phone_number: Yup.string()
            .required('Please enter Phone number.')
            .trim()
            .min(7, 'Phone number must be more than 7 characters.')
            .max(15, 'Phone number should not exceed 15 characters.')
            .matches(/^[0-9]+$/, 'Phone number must be numeric.'),
        location: Yup.string()
            .required('Please enter location.')
            .trim()
            .min(5, 'Location must be more than 10 characters.')
            .max(50, 'Location should not exceed 50 characters.'),
        owner_experience: Yup.number()
            .required('Owner experience is required.')
            .min(0, 'Owner experience cannot be less than 0 years.')
            .max(20, 'Owner experience cannot exceed 20 years.')
            .transform(value => Math.round(value * 100) / 100),
         email: Yup.string()
                .email('Invalid email format.')
                .required('Email is required.')
                .trim() 
                .test(
                    'contains-dot',
                    'Email must contain a dot (.) in the domain part.',
                    value => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
                  ),
    });

    const { register, formState: { errors }, handleSubmit, watch, setValue } = useForm<FormInputs>({
        resolver: yupResolver(formSchema),
    });

    const onSubmit = async (data: any) => {
        const totalimage = salondata?.buisness_images.length + images.length
        if (totalimage < 5) {
            toast.error("Please select at least 5 business images.");
            return; // Exit early if images are not sufficient
        }
    
        setLoading(true);
        const formData = new FormData();
        formData.append('salon_id', salondata?.id.toString());
        formData.append('description', data?.description);
        formData.append('email', data?.email);
        formData.append('location', data?.location);
        formData.append('owner_experience', data?.owner_experience);
        formData.append('owner_name', data?.owner_name);
        formData.append('phone_number', data?.phone_number);
        formData.append('salon_name', data?.salon_name);
        formData.append('phone_country_code', data?.phone_country_code);

        if (images.length >= 1) {
            images.forEach((image: File) => {
                formData.append('buisness_images', image);
            });
        }
        await dispatch(SalonUpdateAction(formData));
        setLoading(false);
    };

    useEffect(() => {
        setLoading(true)
        var params = {
            detail_id: decodeID(editId)
        };
        if (editId) {
            dispatch(SalonDetailsAction(params));
            setTimeout(() => {
                setLoading(false)
            }, 1000);
        }
    }, [dispatch, editId]);

    useEffect(() => {
        if (updateStatus?.data?.status || deleteStatus?.data?.status) {
            setLoading(false)
            if (updateStatus.status) {
                setTimeout(() => {
                    navigate("/salon-list")
                }, 1000);
            }
            var params = {
                detail_id: decodeID(editId)
            };
            if (editId) {
                dispatch(SalonDetailsAction(params));
            }
        }
    }, [updateStatus?.data, deleteStatus?.data])
    useEffect(() => {
        return () => {
            dispatch(SalonDetailsAction('RESET'));
            dispatch(SalondeletebusinessAction('RESET'));
            dispatch(SalonUpdateAction('RESET'));
        }
    }, [])
    useEffect(() => {

        setValue("salon_name", salondata?.salon_name)
        setValue("location", salondata?.location)
        setValue("description", salondata?.description)
        setValue("phone_number", salondata?.phone_number)
        setValue("owner_name", salondata?.owner_name)
        setValue("email", salondata?.email)
        setValue("owner_experience", salondata?.owner_experience)
        setValue('phone_country_code', salondata?.phone_country_code);

    const getclasss =   document.getElementsByClassName("form-control f-input w-100")
    if(getclasss.length > 0){
            // @ts-ignore
        getclasss.forEach(element => {
        element.disabled = true
         });
        }
          
    }, [salondata])

    const handlePhoneNumber = (value: any, code: any, phone: any) => {
        const country_code = `+${value}`
        setValue('phone_country_code', country_code);
    }

    const handleback =()=>{
        if(salondata?.buisness_images.length < 5){
           return toast.error("Please save business images.")
        }else{
           navigate("/salon-list")  
        }
    }

    return (
        <Fragment>
            {loading || log_in?.loading ? <Spinner /> : ""}
            <PageLayout
                title="Salon Edit Management"
                breadcrumbs={{
                    secLast: { 'link': '/salon-list', 'name': 'Salon List Management' },
                }}
                buttons={[
                    { url: '/class-add', className: 'btn btn-primary', text: '+ Add Sponsors', show: false }, // This button will be shown
                ]}
            >
                <div className="mt-4">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="card">
                            <div className="card-body">
                                <div className="row gy-4">
                                    <div className="col-12">
                                        <h5>Registration Details</h5>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="row">
                                            <div className="col-md-4 col-lg-5 col-xl-3">
                                                <label htmlFor="username" className="form-label">Salon ID:</label>
                                            </div>
                                            <div className="col-md-8 col-lg-7 col-xl-9">
                                                <span>{salondata?.u_id ? salondata?.u_id : '--'}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="row">
                                            <div className="col-md-4 col-lg-5 col-xl-3">
                                                <label htmlFor="username" className="form-label">Salon Name:</label>
                                            </div>
                                            <div className="col-md-8 col-lg-7 col-xl-9">
                                                <input type="text" className="form-control mb-0" id="username" placeholder="Enter salon name" {...register("salon_name", {
                                                    required: "Please enter salon_name",

                                                })}

                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    name="salon_name"
                                                    render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="row">
                                            <div className="col-md-4 col-lg-5 col-xl-3">
                                                <label htmlFor="username" className="form-label">Email Address:</label>
                                            </div>
                                            <div className="col-md-8 col-lg-7 col-xl-9">
                                                <input type="email" className="form-control mb-0"  {...register("email", {
                                                    required: "Please enter salon email.",
                                                    pattern: {
                                                        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                                                        message: "Enter valid email address."
                                                    }
                                                })} />
                                                <ErrorMessage
                                                    errors={errors}
                                                    name="email"
                                                    render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="row">
                                            <div className="col-md-4 col-lg-5 col-xl-3">
                                                <label htmlFor="username" className="form-label">Phone Number</label>
                                            </div>
                                            <div className="col-md-8 col-lg-7 col-xl-9">
                                                <div className="row gx-0">
                                                    <div className="col-3 col-md-5 col-xl-4 col-xxl-3">
                                                        <CommanPhoneNumber   handleMobileNumber={handlePhoneNumber}  value={salondata?.phone_country_code} />
                                                    </div>
                                                    <div className="col-9 col-md-7 col-xl-8 col-xxl-9">
                                                        <input type="text" className="form-control mb-0" {...register("phone_number", {
                                                            required: "Please enter salon Phone number.",

                                                        })} />
                                                    </div>
                                                    <div className="col-12">
                                                        <ErrorMessage
                                                            errors={errors}
                                                            name="phone_number"
                                                            render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                                                        />
                                                    </div>
                                                </div>
                                                {/* <span>{salondata ? `${salondata?.phone_country_code || '--'}` : '--'}</span> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="row">
                                            <div className="col-md-4 col-lg-5 col-xl-3">
                                                <label htmlFor="username" className="form-label">Salon Owner Experience</label>
                                            </div>
                                            <div className="col-md-8 col-lg-7 col-xl-9">
                                                {/* <span>{salondata?.owner_experience ? salondata?.owner_experience : '--'}</span> */}
                                                <input type="text" className="form-control mb-0"
                                                    {...register("owner_experience", {
                                                        required: "Please enter salon owner experience",

                                                    })} />
                                                <ErrorMessage
                                                    errors={errors}
                                                    name="owner_experience"
                                                    render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-body">
                                <div className="row gy-4">
                                    <div className="col-12">
                                        <h5>Salon Details</h5>
                                    </div>


                                    <div className="col-lg-6">
                                        <div className="row">
                                            <div className="col-md-4 col-lg-5 col-xl-3">
                                                <label htmlFor="username" className="form-label">Salon Description</label>
                                            </div>
                                            <div className="col-md-8 col-lg-7 col-xl-9">
                                                {/* <span>{salondata?.description ? salondata?.description : '--'}</span> */}
                                                <textarea className="form-control mb-0"  {...register("description", {
                                                    required: "Please enter salon description.",

                                                })} />
                                                <ErrorMessage
                                                    errors={errors}
                                                    name="description"
                                                    render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="row">
                                            <div className="col-md-4 col-lg-5 col-xl-3">
                                                <label htmlFor="username" className="form-label">Salon Owner Name</label>
                                            </div>
                                            <div className="col-md-8 col-lg-7 col-xl-9">
                                                {/* <span>{salondata?.owner_name ? salondata?.owner_name : '--'}</span> */}
                                                <input type="text" className="form-control mb-0"
                                                    {...register("owner_name", {
                                                        required: "Please enter salon Owner name.",

                                                    })} />
                                                <ErrorMessage
                                                    errors={errors}
                                                    name="owner_name"
                                                    render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="row">
                                            <div className="col-md-4 col-lg-5 col-xl-3">
                                                <label htmlFor="username" className="form-label">Salon Location</label>
                                            </div>
                                            <div className="col-md-8 col-lg-7 col-xl-9">
                                                {/* <span>{salondata?.owner_experience ? salondata?.owner_experience : '--'}</span> */}
                                                <input type="text" className="form-control mb-0"
                                                    {...register("location", {
                                                        required: "Please enter salon location",

                                                    })} />
                                                <ErrorMessage
                                                    errors={errors}
                                                    name="location"
                                                    render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* <div className="col-md-8 col-xl-9">
                                <label htmlFor="username" className="form-label">Business Images</label>
                                <div className="cat-img-view-row">
                                    {salondata?.buisness_images.length > 0 ? salondata.buisness_images.map((res: any, index: any) => (
                                        <div className="cat-img-view" key={index}>
                                            <img
                                                src={res?.buisness_images?.image_details?.file_path}
                                                className="rounded-circle"
                                                alt=""
                                            />
                                        </div>
                                    )) : "No business images"}

                                </div>
                            </div> */}
                                    <div className="col-md-12">
                                        <label htmlFor="username" className="form-label">Business Images</label>
                                        <div className="cat-img-view-row align-items-center">
                                            {renderImages()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mt-3 ">
                            <a  type="submit" className="btn btn-primary waves-effect waves-light me-2" onClick={()=>handleback()} >BACK</a>
                            <button type="submit" className="btn theme-bg text-white me-2">SAVE</button>
                        </div>
                    </form>
                </div>
                <div className="mt-3 ">
                </div>

                <ToastDefault />
            </PageLayout>
        </Fragment>
    );
}

export default SalonEdit